<div class="formfield">
    <label for="issuerList" class="nes-my-3">
      <nes-text color="blue" weight="bold">
        {{ "AGREEMENT.INPUT.ISSUER.LABEL" | translate }}
      </nes-text>
    </label>
    <select
      class="nes-border-spacing-5"
      [cypress]="'issuer'"
      (ngModelChange)="selected.emit($event)"
      [(ngModel)]="selectedIssuerId"
      class="select nes-w-full nes-mr-0 xl:nes-mr-10"
      id="issuerList"
    >
      <option value="0" disabled>
        {{ "AGREEMENT.INPUT.ISSUER.DROPDOWN.CHOOSE" | translate }}
      </option>
      <option *ngFor="let issuer of issuers" [value]="issuer.id">
        {{ issuer.displayName }}
      </option>
    </select>

  <div *ngIf="issuerRequiredError">
    <nes-message-inline type="error" class="nes-mt-10">
      {{ "AGREEMENT.INPUT.ISSUER.ERROR_REQUIRED" | translate }}
    </nes-message-inline>
  </div>
</div>
